import {pricingSensitivityMatrix, pricingSensitivityMatrixIncrease} from './pricing-sensitivity-matrix';
import {pmtFunction} from "../../../UnderwritingSingleTenant/single-tenant-tables/constants";

const incomeAndExpensesIndex = 0;
const occIndex = 1;
const currentIndex = 2;
const perSFIndex = 3;
const perOccSFIndex = 4;
const proformaIndex = 6;
const proformaOccIndex = 5;
const proformaPSFIndex = 7;

export default {
    name: 'Pricing',
    tables: {
        'pricing-analysis': {
            name: 'Pricing Analysis',
            rows: {
                'pricing-analysis': {
                    valueCells: [{
                        editable: false, getComputedValue() {
                            return {displayValue: 'Analysis Date'}
                        }
                    }, {
                        editable: true,
                        type: 'date',
                        value: ''
                    }]
                }
            }
        },
        'pricing-sensitivity-matrix': pricingSensitivityMatrix,
        'pricing-sensitivity-matrix-increase': pricingSensitivityMatrixIncrease,
        'header': {
            rows: {
                'header': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Income & Expenses'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Current'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'PSF'};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Pro Forma'};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'PSF'};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    },]
                }
            }
        },
        'base-rent': {
            rows: {
                'header': {
                    valueCells: [{
                        editable: false,
                        hasExpandButton: true,
                        getComputedValue() {
                            return {displayValue: 'Base Rent'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: '% Occ.'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: '% Occ.'};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Occ. PSF'};
                        }
                    },]
                },
                'occupied-space': {
                    valueCells: [{
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['current-rr-tab'].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            return {internalValue: value, displayValue: `Occupied Space (${value.toLocaleString()} SF)`}
                        }
                    }, {
                        editable: false,
                        tooltip: '= occupied_space / (occupied_space + vacant_space)',
                        getComputedValue(tabs, precomputedValues) {
                            const occupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const vacantSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(occupiedSpace / (occupiedSpace + vacantSpace) * 100);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[14].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= current_price_occupied_space / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const occupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(occupiedSpace / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= occupied_space / (occupied_space + vacant_space)',
                        getComputedValue(tabs, precomputedValues) {
                            const occupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const vacantSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(occupiedSpace / (occupiedSpace + vacantSpace) * 100);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[14].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= pro_forma_price_occupied_space / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const occupiedSpacePrice = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(occupiedSpacePrice / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= pro_forma_price_occupied_space / occupied_space',
                        getComputedValue(tabs, precomputedValues) {
                            const occupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const pfOccupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(pfOccupiedSpace / occupiedSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },]
                },
                'vacant-space': {
                    valueCells: [{
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['current-rr-tab'].tables['sumed-general-information'].rows['second-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            return {internalValue: value, displayValue: `Vacant Space (${value.toLocaleString()} SF)`}
                        }
                    }, {
                        editable: false,
                        tooltip: '= vacant_space / (occupied_space + vacant_space)',
                        getComputedValue(tabs, precomputedValues) {
                            const occupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const vacantSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(vacantSpace / (occupiedSpace + vacantSpace) * 100);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {internalValue: 0, displayValue: '$0'}
                        }
                    }, {
                        editable: false,
                        tooltip: '= current_price_vacant_space / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const vacantSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(vacantSpace / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= vacant_space / (occupied_space + vacant_space)',
                        getComputedValue(tabs, precomputedValues) {
                            const occupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const vacantSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(vacantSpace / (occupiedSpace + vacantSpace) * 100);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs) {
                            let value = 0;
                            const generalRows = tabs['proforma-rr-tab'].tables['general-information'].rows;
                            const rows = tabs['proforma-rr-tab'].tables['detailed-information'].rows;
                            Object.keys(rows).forEach(key => {
                                const annualEffectiveRent = rows[key].valueCells[14].getComputedValue(tabs, key).internalValue;
                                const tenant = generalRows[key].valueCells[1].value || '';
                                value = annualEffectiveRent && tenant.toUpperCase() === 'LEASE UP' ? value + parseFloat(annualEffectiveRent) : value;
                            });
                            if (value < 0) return {internalValue: -1, displayValue: '-'};
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= pro_forma_price_vacant_space / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const pfVacantSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(pfVacantSpace / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= pro_forma_price_vacant_space / vacant_space',
                        getComputedValue(tabs, precomputedValues) {
                            const pfVacantSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const vacantSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[incomeAndExpensesIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(pfVacantSpace / vacantSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },]
                },
                'additional-price': {
                    valueCells: [{
                        editable: true,
                        hidden: true,
                        type: 'text',
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: true,
                        hidden: true,
                        type: 'number',
                        unit: '$',
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    },]
                },
            },
            footerRow: {
                valueCells: [{
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'GROSS RENTAL REVENUE'}
                    }
                }, {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    tooltip: '= current_price_occupied_space + current_price_vacant_space + current_price_additional',
                    getComputedValue(tabs, precomputedValues) {
                        let currentOccupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const vacantOccupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const additionalPrice = parseInt(tabs['pricing-tab'].tables['base-rent'].rows['additional-price'].valueCells[currentIndex].value) || 0;
                        if (typeof currentOccupiedSpace === 'string') {
                            currentOccupiedSpace = parseInt(currentOccupiedSpace);
                        }
                        const value = currentOccupiedSpace ? parseFloat(currentOccupiedSpace + vacantOccupiedSpace + additionalPrice) : null;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    tooltip: '= gross_rental_revenue / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const value = parseFloat(precomputedValues.grossRentalRevenue / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, { // Pro Forma
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= pro_forma_price_occupied_space + pro_forma_price_vacant_space',
                    getComputedValue(tabs, precomputedValues) {
                        let pfOccupiedSpace = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const pfVacantSpace = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        if (typeof pfOccupiedSpace === 'string') {
                            pfOccupiedSpace = parseInt(pfOccupiedSpace);
                        }
                        const value = pfOccupiedSpace ? parseFloat(pfOccupiedSpace + pfVacantSpace) : null;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue(tabs, precomputedValues) {
                        let pfOccupiedSpacePSF = tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[proformaPSFIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const pfVacantSpacePSF = tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[proformaPSFIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        if (typeof pfOccupiedSpacePSF === 'string') {
                            pfOccupiedSpacePSF = parseInt(pfOccupiedSpacePSF);
                        }
                        const value = pfOccupiedSpacePSF ? parseFloat(pfOccupiedSpacePSF + pfVacantSpacePSF) : null;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= gross_rental_revenue / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const pfGrossRentalRevenue = tabs['pricing-tab'].tables['base-rent'].footerRow.valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat(pfGrossRentalRevenue / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },]
            }
        },
        'exp-reimb': {
            name: 'Exp. Reimb.',
            rows: {
                'header': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Exp. Reimb.'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    },]
                },
                'real-estate-taxes': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Real Estate Taxes'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[3].getComputedValue(tabs, 'first-row', precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= real_estate_taxes / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const realEstateTaxes = tabs['pricing-tab'].tables['exp-reimb'].rows['real-estate-taxes'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(realEstateTaxes / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['proforma-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[3].getComputedValue(tabs, 'first-row', precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= real_estate_taxes / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const realEstateTaxes = tabs['pricing-tab'].tables['exp-reimb'].rows['real-estate-taxes'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(realEstateTaxes / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
                'insurance': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Insurance'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[5].getComputedValue(tabs, 'first-row', precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= insurance / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const insurance = tabs['pricing-tab'].tables['exp-reimb'].rows['insurance'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(insurance / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['proforma-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[5].getComputedValue(tabs, 'first-row', precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= insurance / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const insurance = tabs['pricing-tab'].tables['exp-reimb'].rows['insurance'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(insurance / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
                'cam': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'CAM'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[7].getComputedValue(tabs, '', precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const cam = tabs['pricing-tab'].tables['exp-reimb'].rows['cam'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(cam / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['proforma-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[7].getComputedValue(tabs, '', precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const cam = tabs['pricing-tab'].tables['exp-reimb'].rows['cam'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(cam / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
                'mgmt-fee': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Mgmt. Fee'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        tooltip: '= annual_mgmt_fee + annual_other',
                        getComputedValue(tabs, precomputedValues) {
                            const annualMgmtFee = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[9].getComputedValue(tabs, 'first-row', precomputedValues).internalValue;
                            const annualOther = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[11].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = Math.round(annualMgmtFee + annualOther);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= mgmt_fee / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const mgmtFee = tabs['pricing-tab'].tables['exp-reimb'].rows['mgmt-fee'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(mgmtFee / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= annual_mgmt_fee + annual_other',
                        getComputedValue(tabs, precomputedValues) {
                            const annualMgmtFee = tabs['proforma-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[9].getComputedValue(tabs, 'first-row', precomputedValues).internalValue;
                            const annualOther = tabs['proforma-reimbursement-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[11].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = Math.round(annualMgmtFee + annualOther);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= mgmt_fee / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const mgmtFee = tabs['pricing-tab'].tables['exp-reimb'].rows['mgmt-fee'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(mgmtFee / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
            },
            footerRow: {
                valueCells: [{
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Total Exp. Reimb.'}
                    }
                }, {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    tooltip: '= real_estate_taxes + insurance + cam + mgmt_fee',
                    getComputedValue(tabs, precomputedValues) {
                        const expReimbRows = tabs['pricing-tab'].tables['exp-reimb'].rows;
                        const value = Object.keys(expReimbRows)
                            .map(rowKey => expReimbRows[rowKey].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue)
                            .reduce((a, b) => {
                                const first = a && !isNaN(a) ? a : 0;
                                const second = b && !isNaN(b) ? b : 0;
                                return Math.round(first + second);
                            });
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    tooltip: '= total_exp_reimb / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const value = parseFloat(precomputedValues.totalExpReimb / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, { // Pro Forma
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= real_estate_taxes + insurance + cam + mgmt_fee',
                    getComputedValue(tabs, precomputedValues) {
                        const expReimbRows = tabs['pricing-tab'].tables['exp-reimb'].rows;
                        const value = Object.keys(expReimbRows)
                            .map(rowKey => expReimbRows[rowKey].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue)
                            .reduce((a, b) => {
                                const first = a && !isNaN(a) ? a : 0;
                                const second = b && !isNaN(b) ? b : 0;
                                return Math.round(first + second);
                            });
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= total_exp_reimb / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const value = parseFloat(precomputedValues.totalExpReimbProForma / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }]
            }
        },
        'total-gross-revenue': {
            name: 'TOTAL GROSS REVENUE',
            rows: {
                'total-gross-revenue': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'TOTAL GROSS REVENUE'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        tooltip: '= gross_rental_revenue + total_exp_reimb',
                        getComputedValue(tabs, precomputedValues) {
                            const value = parseFloat(precomputedValues.grossRentalRevenue + precomputedValues.totalExpReimb);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= total_gross_revenue / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalGrossRevenue = tabs['pricing-tab'].tables['total-gross-revenue'].rows['total-gross-revenue'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(totalGrossRevenue / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= gross_rental_revenue + total_exp_reimb',
                        getComputedValue(tabs, precomputedValues) {
                            const value = parseFloat(precomputedValues.grossRentalRevenueProForma + precomputedValues.totalExpReimbProForma);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= total_gross_revenue / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalGrossRevenue = tabs['pricing-tab'].tables['total-gross-revenue'].rows['total-gross-revenue'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(totalGrossRevenue / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }]
                },
                'vacancy-factor': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Vacancy Factor'}
                        }
                    }, {
                        editable: true,
                        type: 'number',
                        unit: '%',
                        value: '0'
                    }, {
                        editable: false,
                        tooltip: '= total_gross_revenue * vacancy_factor',
                        getComputedValue(tabs, precomputedValues) {
                            const totalGrossRevenue = tabs['pricing-tab'].tables['total-gross-revenue'].rows['total-gross-revenue'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const vacancyFactorPercentage = tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[occIndex].value;
                            const value = parseFloat(totalGrossRevenue * vacancyFactorPercentage / 100);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: -value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= -vacancy_factor / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const vacancyFactor = tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(-vacancyFactor / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: -value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: true,
                        hidden: true,
                        type: 'number',
                        unit: '%',
                        value: '0'
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= total_gross_revenue * vacancy_factor',
                        getComputedValue(tabs, precomputedValues) {
                            const totalGrossRevenue = tabs['pricing-tab'].tables['total-gross-revenue'].rows['total-gross-revenue'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const vacancyFactorPercentage = tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[proformaOccIndex].value;
                            const value = parseFloat(totalGrossRevenue * vacancyFactorPercentage / 100);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: -value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= -vacancy_factor / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const vacancyFactor = tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(-vacancyFactor / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: -value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }]
                },
            },
            footerRow: {
                valueCells: [{
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'EFFECTIVE GROSS REVENUE'}
                    }
                }, {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    tooltip: '= total_gross_revenue + vacancy_factor',
                    getComputedValue(tabs, precomputedValues) {
                        const totalGrossRevenue = tabs['pricing-tab'].tables['total-gross-revenue'].rows['total-gross-revenue'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const vacancyFactor = tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat(totalGrossRevenue + vacancyFactor);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    tooltip: '= effective_gross_revenue / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const value = parseFloat(precomputedValues.effectiveGrossRevenue / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, { // Pro Forma
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= total_gross_revenue + vacancy_factor',
                    getComputedValue(tabs, precomputedValues) {
                        const totalGrossRevenue = tabs['pricing-tab'].tables['total-gross-revenue'].rows['total-gross-revenue'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const vacancyFactor = tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat(totalGrossRevenue + vacancyFactor);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= effective_gross_revenue / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const value = parseFloat(precomputedValues.effectiveGrossRevenueProForma / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''};
                    }
                },]
            }
        },
        'expenses': {
            name: 'Expenses',
            rows: {
                'header': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Expenses'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    },]
                },
                'real-estate-taxes': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Real Estate Taxes'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[2].value);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        tooltip: '= real_estate_taxes / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const realEstateTaxes = tabs['pricing-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(realEstateTaxes / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[5].value);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= real_estate_taxes / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const realEstateTaxes = tabs['pricing-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(realEstateTaxes / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
                'insurance': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Insurance'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['insurance'].valueCells[2].value);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        tooltip: '= insurance / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const insurance = tabs['pricing-tab'].tables['expenses'].rows['insurance'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(insurance / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['insurance'].valueCells[5].value);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= insurance / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const insurance = tabs['pricing-tab'].tables['expenses'].rows['insurance'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(insurance / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
                'cam': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'CAM'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        tooltip: '= cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const cam = tabs['pricing-tab'].tables['expenses'].rows['cam'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(cam / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, { // ProForma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[5].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const cam = tabs['pricing-tab'].tables['expenses'].rows['cam'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(cam / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
                'mgmt-fee': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Mgmt. Fee (% of GPI)'};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[1].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[2].value);
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= mgmt_fee / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const mgmtFee = tabs['pricing-tab'].tables['expenses'].rows['mgmt-fee'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(mgmtFee / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[4].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[5].value);
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= mgmt_fee / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const mgmtFee = tabs['pricing-tab'].tables['expenses'].rows['mgmt-fee'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(mgmtFee / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
                'non-reimbursable-expenses': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Non-Reimbursable Expenses'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[2].value);
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= non_reimbursable_expenses / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const nonReimbursableExpenses = tabs['pricing-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(nonReimbursableExpenses / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[5].value);
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= non_reimbursable_expenses / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const nonReimbursableExpenses = tabs['pricing-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(nonReimbursableExpenses / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : parseInt(value) < 0 ? `($${(-value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }]
                },
            },
            footerRow: {
                valueCells: [{
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Total Expenses'}
                    }
                }, {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    tooltip: '= real_estate_taxes + insurance + cam + mgmt_fee + non_reimbursable_expenses',
                    getComputedValue(tabs, precomputedValues) {
                        const expReimbRows = tabs['pricing-tab'].tables['expenses'].rows;
                        const value = Object.keys(expReimbRows)
                            .map(rowKey => expReimbRows[rowKey].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue)
                            .reduce((a, b) => {
                                const first = a && !isNaN(a) ? a : 0;
                                const second = b && !isNaN(b) ? b : 0;
                                return Math.round(first + second);
                            });
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString()})`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    tooltip: '= total_expenses / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const value = parseFloat(precomputedValues.totalExpenses / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, { // Pro Forma
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= real_estate_taxes + insurance + cam + mgmt_fee + non_reimbursable_expenses',
                    getComputedValue(tabs, precomputedValues) {
                        const expReimbRows = tabs['pricing-tab'].tables['expenses'].rows;
                        const value = Object.keys(expReimbRows)
                            .map(rowKey => expReimbRows[rowKey].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue)
                            .reduce((a, b) => {
                                const first = a && !isNaN(a) ? a : 0;
                                const second = b && !isNaN(b) ? b : 0;
                                return Math.round(first + second);
                            });
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString()})`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= total_expenses / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const value = parseFloat(precomputedValues.totalExpensesProForma / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }]
            }
        },
        'net-operating-income': {
            rows: {
                'net-operating-income': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'NET OPERATING INCOME'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        tooltip: '= effective_gross_revenue + total_expenses',
                        getComputedValue(tabs, precomputedValues) {
                            const totalExpenses = tabs['pricing-tab'].tables['expenses'].footerRow.valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(precomputedValues.effectiveGrossRevenue + (-totalExpenses));
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= net_operating_income / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const value = parseFloat(precomputedValues.netOperatingIncome / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= effective_gross_revenue + total_expenses',
                        getComputedValue(tabs, precomputedValues) {
                            const totalExpenses = tabs['pricing-tab'].tables['expenses'].footerRow.valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(precomputedValues.effectiveGrossRevenueProForma + (-totalExpenses));
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= net_operating_income / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const value = parseFloat(precomputedValues.netOperatingIncomeProForma / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                }
            }
        },
        'annual-debt-service': {
            rows: {
                'annual-debt-service': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Annual Debt Service'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['interest-rate'].rows['annual-loan-payment'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= annual_debt_service / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const annualDebtService = tabs['pricing-tab'].tables['annual-debt-service'].rows['annual-debt-service'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(annualDebtService / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['interest-rate'].rows['annual-loan-payment'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue}

                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= annual_debt_service / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const annualDebtService = tabs['pricing-tab'].tables['annual-debt-service'].rows['annual-debt-service'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(annualDebtService / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `($${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                }
            },
            footerRow: {
                valueCells: [{
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'CASH FLOW'}
                    }
                }, {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    tooltip: '= net_operating_income + annual_debt_service',
                    getComputedValue(tabs, precomputedValues) {
                        const annualDebtService = tabs['pricing-tab'].tables['annual-debt-service'].rows['annual-debt-service'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        let netOperatingIncome = precomputedValues.netOperatingIncome;
                        if (typeof netOperatingIncome === 'string') {
                            netOperatingIncome = parseInt(netOperatingIncome);
                        }
                        const value = parseFloat(netOperatingIncome + (-annualDebtService));
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    tooltip: '= cash_flow / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const value = parseFloat(precomputedValues.cashFlow / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, { // Pro Forma
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= net_operating_income + annual_debt_service',
                    getComputedValue(tabs, precomputedValues) {
                        const annualDebtService = tabs['pricing-tab'].tables['annual-debt-service'].rows['annual-debt-service'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        let netOperatingIncome = precomputedValues.netOperatingIncomeProForma;
                        if (typeof netOperatingIncome === 'string') {
                            netOperatingIncome = parseInt(netOperatingIncome);
                        }
                        const value = parseFloat(netOperatingIncome + (-annualDebtService));
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= cash_flow / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const value = parseFloat(precomputedValues.cashFlowProForma / precomputedValues.totalSpace);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }]
            }
        },
        'value': {
            rows: {
                'value': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'VALUE'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        tooltip: '=ROUNDUP(net_operating_income / cap_rate / 5000) * 5000',
                        getComputedValue(tabs, precomputedValues) {
                            const capRate = tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[currentIndex].value;
                            const value = capRate ? Math.ceil(precomputedValues.netOperatingIncome / (capRate / 100) / 5000) * 5000 : null;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= value / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const value = parseFloat(precomputedValues.pricingValue / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}/SF`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue : ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '=ROUNDUP(net_operating_income / cap_rate / 5000) * 5000',
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['value'].rows['value'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= value / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const value = parseFloat(precomputedValues.pricingValueProForma / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}/SF`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
                'cap-rate': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'CAP RATE'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: true,
                        type: 'number',
                        unit: '%',
                        value: '',
                        withDecimals: true,
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Pro Forma Yield'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= net_operating_income / value',
                        getComputedValue(tabs, precomputedValues) {
                            const value = parseFloat(precomputedValues.netOperatingIncomeProForma / precomputedValues.pricingValueProForma * 100);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
                'cash-on-cash-return': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'CASH ON CASH RETURN'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        tooltip: '= cash_flow / required_equity',
                        getComputedValue(tabs, precomputedValues) {
                            const value = parseFloat(precomputedValues.cashFlow / precomputedValues.requiredEquity * 100);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue}
                        }

                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= cash_flow / required_equity',
                        getComputedValue(tabs, precomputedValues) {
                            const value = parseFloat(precomputedValues.cashFlowProForma / precomputedValues.requiredEquityProForma * 100);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue}
                        }

                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }]
                },
            }
        },
        'required-equity': {
            rows: {
                'required-equity': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Required Equity'}
                        }
                    }, {
                        editable: true,
                        type: 'number',
                        unit: '%',
                        value: 0,
                    }, {
                        editable: false,
                        tooltip: '= value * required_equity',
                        getComputedValue(tabs, precomputedValues) {
                            const requiredEquityPercentage = tabs['pricing-tab'].tables['required-equity'].rows['required-equity'].valueCells[occIndex].value;
                            const value = precomputedValues.pricingValue * requiredEquityPercentage / 100;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Required Equity'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= value * required_equity',
                        getComputedValue(tabs, precomputedValues) {
                            const requiredEquityPercentage = tabs['pricing-tab'].tables['required-equity'].rows['required-equity'].valueCells[occIndex].value;
                            const value = precomputedValues.pricingValueProForma * requiredEquityPercentage / 100;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },  {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },]
                }
            }
        },
        'loan-amount': {
            rows: {
                'loan-amount': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Loan Amount'}
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = 100 - tabs['pricing-tab'].tables['required-equity'].rows['required-equity'].valueCells[1].value;
                            const displayValue = !value || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: '= value - required_equity',
                        getComputedValue(tabs, precomputedValues) {
                            const value = precomputedValues.pricingValue - precomputedValues.requiredEquity;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Loan Amount'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= value - required_equity',
                        getComputedValue(tabs, precomputedValues) {
                            const value = precomputedValues.pricingValueProForma - precomputedValues.requiredEquityProForma;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },]
                }
            },
            footerRow: {
                valueCells: [{
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Total'}
                    }
                }, {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    tooltip: '= loan_amount + required_equity',
                    getComputedValue(tabs, precomputedValues) {
                        const loanAmount = tabs['pricing-tab'].tables['loan-amount'].rows['loan-amount'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = loanAmount + precomputedValues.requiredEquity;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, { // Pro Forma
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: 'Total'}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    tooltip: '= loan_amount + required_equity',
                    getComputedValue(tabs, precomputedValues) {
                        const loanAmount = tabs['pricing-tab'].tables['loan-amount'].rows['loan-amount'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = loanAmount + precomputedValues.requiredEquityProForma;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                }, {
                    editable: false,
                    hidden: true,
                    getComputedValue() {
                        return {displayValue: ''}
                    }
                },]
            }
        },
        'interest-rate': {
            rows: {
                'interest-rate': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Interest Rate'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: true,
                        type: 'number',
                        unit: '%',
                        value: 0,
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Interest Rate'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs) {
                            const value = tabs['pricing-tab'].tables['interest-rate'].rows['interest-rate'].valueCells[currentIndex].value;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString()}%`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },]
                },
                'amortization': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Amortization'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: true,
                        type: 'number',
                        value: 0,
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Amortization'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs) {
                            const value = tabs['pricing-tab'].tables['interest-rate'].rows['amortization'].valueCells[currentIndex].value;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },]
                },
                'annual-loan-payment': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Annual Loan Payment'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        tooltip: '= -PMT(interest_rate/12, amortization*12, loan_amount) * 12',
                        getComputedValue(tabs, precomputedValues) {
                            const loanAmount = tabs['pricing-tab'].tables['loan-amount'].rows['loan-amount'].valueCells[currentIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const interestRate = tabs['pricing-tab'].tables['interest-rate'].rows['interest-rate'].valueCells[currentIndex].value;
                            const amortization = tabs['pricing-tab'].tables['interest-rate'].rows['amortization'].valueCells[currentIndex].value;
                            const value = parseInt(-pmtFunction(interestRate / 100 / 12, amortization * 12, loanAmount) * 12);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Annual Loan Payment'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= -PMT(interest_rate/12, amortization*12, loan_amount) * 12',
                        getComputedValue(tabs, precomputedValues) {
                            const loanAmount = tabs['pricing-tab'].tables['loan-amount'].rows['loan-amount'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const interestRate = tabs['pricing-tab'].tables['interest-rate'].rows['interest-rate'].valueCells[proformaIndex].getComputedValue(tabs).internalValue;
                            const amortization = tabs['pricing-tab'].tables['interest-rate'].rows['amortization'].valueCells[proformaIndex].getComputedValue(tabs).internalValue;
                            const value = parseInt(-pmtFunction(interestRate / 100 / 12, amortization * 12, loanAmount) * 12);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },]
                },
            }
        },
        'proforma-capital-req': {
            rows: {
                'tenant-improvements': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'PROFORMA CAPITAL REQUIREMENTS'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Tenant Improvements'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const tenantImprovements = tabs['proforma-rr-tab'].tables['sumed-detailed-information'].rows['second-row'].valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;
                            return {internalValue: tenantImprovements, displayValue: `$${tenantImprovements.toLocaleString(undefined, {maximumFractionDigits: 2})}`}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= tenant_improvements / lease_up_space',
                        getComputedValue(tabs, precomputedValues) {
                            const tenantImprovements = tabs['pricing-tab'].tables['proforma-capital-req'].rows['tenant-improvements'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const leaseUpSpace = tabs['proforma-rr-tab'].tables['sumed-general-information'].rows['second-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = leaseUpSpace ? parseFloat(tenantImprovements / leaseUpSpace) : 0;
                            const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },]
                },
                'leasing-commissions': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Leasing Commissions'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const leasingCommissions = parseInt(tabs['proforma-rr-tab'].tables['sumed-detailed-information'].rows['second-row'].valueCells[7].getComputedValue(tabs, precomputedValues).internalValue);
                            return {internalValue: leasingCommissions, displayValue: `$${leasingCommissions.toLocaleString(undefined, {maximumFractionDigits: 2})}`}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= leasing_commissions / lease_up_space',
                        getComputedValue(tabs, precomputedValues) {
                            const leasingCommissions = tabs['pricing-tab'].tables['proforma-capital-req'].rows['leasing-commissions'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const leaseUpSpace = tabs['proforma-rr-tab'].tables['sumed-general-information'].rows['second-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = leaseUpSpace ? parseFloat(leasingCommissions / leaseUpSpace) : 0;
                            const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },]
                },
                'total': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Pro Forma Adjusted Basis COC Return'}
                        }
                    }, {
                        editable: false,
                        tooltip: '= cash_flow / (required_equity + total)',
                        getComputedValue(tabs, precomputedValues) {
                            const total = tabs['pricing-tab'].tables['proforma-capital-req'].rows['total'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(precomputedValues.cashFlowProForma / (precomputedValues.requiredEquityProForma + total) * 100);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Total'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= tenant_improvements + lease_up_space',
                        getComputedValue(tabs, precomputedValues) {
                            const tenantImprovements = tabs['pricing-tab'].tables['proforma-capital-req'].rows['tenant-improvements'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const leasingCommissions = tabs['pricing-tab'].tables['proforma-capital-req'].rows['leasing-commissions'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(tenantImprovements + leasingCommissions);
                            const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= total / lease_up_space',
                        getComputedValue(tabs, precomputedValues) {
                            const total = tabs['pricing-tab'].tables['proforma-capital-req'].rows['total'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const leaseUpSpace = tabs['proforma-rr-tab'].tables['sumed-general-information'].rows['second-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = leaseUpSpace ? parseFloat(total / leaseUpSpace) : 0;
                            const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },]
                },
                'adjusted-basis': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Pro Forma Adjusted Basis Yield'}
                        }
                    }, {
                        editable: false,
                        tooltip: '= net_operating_income / adjusted_basis',
                        getComputedValue(tabs, precomputedValues) {
                            const adjustedBasis = tabs['pricing-tab'].tables['proforma-capital-req'].rows['adjusted-basis'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(precomputedValues.netOperatingIncomeProForma / adjustedBasis * 100);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Adjusted Basis'}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= value + total',
                        getComputedValue(tabs, precomputedValues) {
                            const total = tabs['pricing-tab'].tables['proforma-capital-req'].rows['total'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseInt(precomputedValues.pricingValueProForma + total);
                            const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: '= adjusted_basis / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const adjustedBasis = tabs['pricing-tab'].tables['proforma-capital-req'].rows['adjusted-basis'].valueCells[proformaIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(adjustedBasis / precomputedValues.totalSpace);
                            const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    },]
                },
            }
        },
    }
}